<div class="toolbar">
  @if(authenticationService.isSignedIn$ | async) {
    <div class="language">
      <af-translator></af-translator>
    </div>
    <div class="profile">
      <kendo-menu (select)="onSelect($event)">
        <kendo-menu-item text="{{ authenticationService.userName$ | async }}" [cssStyle]="{ color: 'white' }">
          @if(oidcEnabled == false) {
            <kendo-menu-item text="{{ 'HEADER.CHANGE_PASSWORD' | translate }}" url="/change-password"></kendo-menu-item>
          }
          <kendo-menu-item text="{{ 'HEADER.LOGOUT' | translate }}" [data]="{ action: 'logout' }"></kendo-menu-item>
        </kendo-menu-item>
      </kendo-menu>
    </div>
  }
</div>
